import { render } from "./NotificationsTable.vue?vue&type=template&id=3cd6250f&scoped=true"
import script from "./NotificationsTable.vue?vue&type=script&lang=js"
export * from "./NotificationsTable.vue?vue&type=script&lang=js"

import "./NotificationsTable.vue?vue&type=style&index=0&id=3cd6250f&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd6250f"]])

export default __exports__